module.exports = __webpack_public_path__ + "img/solution1_banner.7a07e762.png";